import applyPattern from '../helpers/applyPattern';

function flightNumberFormatter(value, prevValue, cursor) {
  const flightNumberData = applyPattern(value, cursor, /\s/g, () => '11 1111');
  const uppercasedValue = {
    ...flightNumberData,
    value: flightNumberData.value && flightNumberData.value.toUpperCase(),
  };

  return uppercasedValue;
}

export default flightNumberFormatter;
